import React from 'react';
export function UrgencyBanner() {
  return <div className="bg-brand-charcoal text-white py-2 px-4 text-center" data-id="element-216">
      <p className="text-xs sm:text-sm font-semibold" data-id="element-217">
        🇨🇭 100% Industrie 4.0 Ready · Schweizer Industriestandard 2026
      </p>
    </div>;
}